// Where the Bosla app is downloaded (#392, #393): the till files site,
// https://till.<domain>, which main's till job publishes after the API. Its host
// derives from the API's, as the order store derives it
// (internal/tillapp.FilesSiteFor): api.<domain> becomes till.<domain>. A build
// may name it outright with VITE_TILL_BASE, as the browser flows do; a build
// that can name neither shows no download.

/** The Windows installer's file on the till files site. */
export const WINDOWS_INSTALLER = 'Bosla-setup.exe';

/** The Android app's file on the till files site. */
export const ANDROID_APK = 'Bosla.apk';

/** The till files site for this build, or null when it has none. */
export function tillFilesBase(
	explicit: string | undefined,
	api: string | undefined,
): string | null {
	const named = explicit?.trim();
	if (named) return named.replace(/\/+$/, '');
	if (!api) return null;
	let url: URL;
	try {
		url = new URL(api);
	} catch {
		return null;
	}
	if (!url.hostname.startsWith('api.')) return null;
	return `${url.protocol}//till.${url.host.slice('api.'.length)}`;
}

/** The Windows installer's address for this build, or null. */
export function windowsDownload(
	explicit: string | undefined = import.meta.env.VITE_TILL_BASE,
	api: string | undefined = import.meta.env.VITE_API_BASE,
): string | null {
	const base = tillFilesBase(explicit, api);
	return base === null ? null : `${base}/${WINDOWS_INSTALLER}`;
}

/** The Android app's address for this build, or null. */
export function androidDownload(
	explicit: string | undefined = import.meta.env.VITE_TILL_BASE,
	api: string | undefined = import.meta.env.VITE_API_BASE,
): string | null {
	const base = tillFilesBase(explicit, api);
	return base === null ? null : `${base}/${ANDROID_APK}`;
}
